'use client'

import { Leaf } from 'lucide-react'

const HeroAnimations = () => null

export default HeroAnimations
